import React, { useRef, useState, FunctionComponent } from "react";
import { makeThemedStyles } from "@qpr/client-api-base/viewcomponents/utils";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import { IconButton, Menu, MenuItem } from "@material-ui/core";
import DelegateModal from "./DelegateModal";
const useStyle = makeThemedStyles("MyTasksMenuBtn", (theme) => ({
  menuItem: {
    color: "#0060df",
    width: "100%",
    cursor: "pointer",
    fontSize: "16px",
    "&::before": {
      display: "none",
    },
  },
}));

type TMenuItem = { name: string; title: string };
interface MyTasksMenuBtnProps {
  items: Array<TMenuItem>;
  onSelected: (item: TMenuItem) => void;
}

const MyTasksMenuBtn: FunctionComponent<MyTasksMenuBtnProps> = (props) => {
  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);
  const styles = useStyle();

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    console.log("event.currentTarget", event.currentTarget);
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <>
      <div>
        <IconButton
          onClick={handleClick}
          aria-describedby={Boolean(anchorEl) ? "simple-popover" : undefined}
        >
          <MoreVertIcon />
        </IconButton>
      </div>
      <Menu
        id={Boolean(anchorEl) ? "simple-popover" : undefined}
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        {props.items.map((item) => {
          return (
            <MenuItem
              key={item.name}
              onClick={() => {
                props.onSelected(item);
                handleClose();
              }}
              className={styles.menuItem}
            >
              {item.title}
            </MenuItem>
          );
        })}
      </Menu>
    </>
  );
};

export default MyTasksMenuBtn;
